:host {
  /* Component styles go here */
}

.user-col {
  display: grid;
  grid-auto-flow: row;
  gap: 10px;

  > dc-ui-link {
    font-weight: bold;
  }
}
